import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('substanciasuso');

export const check = () => useBasicAuth.checkToken();

export const findSubstanciaUsoById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSubstanciaUso = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSubstanciaUsoByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllSubstanciaUsoByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addSubstanciaUso = (obj) => 
  axios.post(urlAPI + "/addSubstanciaUso" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateSubstanciaUso = (obj) => 
  axios.put(urlAPI + "/updateSubstanciaUso/" + obj.substanciaUso.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteSubstanciaUso = (id) => 
  axios.delete(urlAPI + "/deleteSubstanciaUso/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



//SUBSTANCIA_SUBSTANCIA_USO
export const findAllBySubstanciaSubstanciaUso_substancia = (substancia) => 
  axios.post(urlAPI + "/substanciasubstanciaUso/substancia", JSON.stringify(substancia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllBySubstanciaSubstanciaUso_substanciaUso = (substanciaUso) => 
  axios.post(urlAPI + "/substanciasubstanciaUso/substanciaUso", JSON.stringify(substanciaUso), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllBySubstanciaSubstanciaUso = (substancia, substanciaUso) => {
  let requestObj = {
    substancia: substancia,
    substanciaUso: substanciaUso
  }
  axios.post(urlAPI + "/substanciasubstanciaUso", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}
  
export const findAllSubstanciaSubstanciaUso = () => 
  axios.get(urlAPI + "/substanciasubstanciaUsos", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
});
